import React, { useState, useEffect, useContext, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import { Collapse, Modal, Button, Checkbox, Alert } from 'antd';

import { G, PDFDownloadLink } from '@react-pdf/renderer';
import PDFFile, { svgToDataURI } from 'components/PDF/PDFFile';

import icon_export from 'images/new_pop_ups/export.svg';

import moment from 'moment';

import { getAnalysisResults } from 'services/project';
import { AppContext } from 'context/AppContext';
import Loader from 'components/Loader';

import AutoregressionChart from './components/AutoregressionChart';
import BoxplotChart from './components/BoxplotChart';
import DotplotChart from './components/DotplotChart';
import TimeplotChart from './components/TimeplotChart';
import ConfidenceIntervalsChart from './components/ConfidenceIntervalsChart';
import HistogramChart from './components/HistogramChart';
import QQPlotChart from './components/QQPlotChart';
import GeneralStatistics from './components/GeneralStatistics';

import AutoregressionScatterplotChart from './components/AutoregressionScatterplotChart';
import AutoregressionStatistics from './components/AutoregressionStatistics';
import ConfidenceIntervalsStatistics from './components/ConfidenceIntervalsStatistics';
import AutoregressionMultiChart from './components/AutoregressionMultiChart';
import RegressionMultiChart from './components/RegressionMultiChart';
import ScatterplotMultiChart from './components/ScatterplotMultiChart';
import RemovedOutliers from './components/RemovedOutliers';
import RemovedOutliersMultivariate from './components/RemovedOutliersMultivariate';
import WlsExcludedRows from './components/WlsExcludedRows';
import TslsMultiChart from './components/TslsMultiChart';
import RobustRegressionMultiChart from './components/RobustRegressionMultiChart';
import RobustStatistics from './components/RobustStatistics';
import ServerError from 'components/modal/ServerError';
import background_circle_red_modal from 'images/background_circle_red_modal.svg';
import icon_in_red_circle from 'images/icon_in_red_circle.svg';


require('highcharts/modules/exporting')(Highcharts);

const FullProjectView = (props) => {
    let appContext = useContext(AppContext);

    let refToScroll = useRef();

    const { Panel } = Collapse;

    const [getAnalysisRes, setGetAnalysisRes] = useState('');


    const [showModalError, setShowModalError] = useState(false);
    const [errorModalIsVisible, setErrorModalIsVisible] = useState(false);
    const handleErrorModalOk = () => {
        setErrorModalIsVisible(false);
        // window.location.reload(false);
    };
    const handleCancelErrorModal = () => {
        setErrorModalIsVisible(false);
    };

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const getWindowSize = () => {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    };

    const [windowSize, setWindowSize] = useState(getWindowSize());

    const [chartVariableName, setChartVariableName] = useState('');
    const [msgError, setMsgError] = useState('');

    HighchartsMore(Highcharts);

    useEffect(() => {
        props.setSpinnerFullProjectView(true);

        setTimeout(() => {
            getAnalysisResults(props.analysisId).then((res) => {
                setChartVariableName(res.data.display_name);
                setGetAnalysisRes(res.data);
                props.setSpinnerFullProjectView(false);

            })
            .catch(({name, message})=>{
                console.log(`error occured!`, name, message)
                props.setSpinnerFullProjectView(false);
                setShowModalError(true)
                setErrorModalIsVisible(true)
            })
            setTimeout(() => window.dispatchEvent(new Event('resize')));
        }, 300);

        setTimeout(() => {
            let scrollToElement = document.querySelector(
                '#id-' + props.scrollToFunction
            );
            if (scrollToElement !== null) {
                scrollToElement.scrollIntoView({ behavior: 'smooth' }, false);
            }
        }, 1000);

        props.setGetSvg(false);
    }, [props.analysisId, props.rerenderAnalysisView]);
    // }, [props.analysisId]);
    // /////////////////////////////////////////////////////////

    let styleCss = {
        height: props.viewportHighChart,
        width: '100%',
        overflowY: 'scroll',
        position: 'relative'
    };

    const [checkedList, setCheckedList] = useState(
        props.analysisData[props.analysisActivePanel]?.analysis_function
    );

    let strStatisticsOptions = false;

    const [allSelected, setAllSelected] = useState(true);
    const [noneSelected, setNoneSelected] = useState(false);

    const onChange = (checkedValues) => {
        setCheckedList(checkedValues);
    };

    const onOkExport = () => {
        appContext.setIsModalExport(false);
    };

    const onCancelExport = () => {
        appContext.setIsModalExport(false);
    };

    const handleOnClickAll = () => {
        setNoneSelected(false);
        setAllSelected(true);
        setCheckedList(
            props.analysisData[props.analysisActivePanel]?.analysis_function
        );
    };
    const handleOnClickNone = () => {
        setNoneSelected(true);
        setAllSelected(false);
        setCheckedList([]);
    };

    const [plainOptions, setPlainOptions] = useState(
        props.analysisData[props.analysisActivePanel]?.analysis_function
    );

    useEffect(() => {
        setPlainOptions(
            props.analysisData[props.analysisActivePanel]?.analysis_function
        );

        setCheckedList(
            props.analysisData[props.analysisActivePanel]?.analysis_function
        );
    }, [props.analysisData[props.analysisActivePanel]?.analysis_function]);

    const [svgChartsList, setSvgChartsList] = useState({});

    const testRef = useRef(null);
    //  Refs Statistics
    const statisticsAutoregression = useRef(null);
    const statisticsConfidenceIntervals = useRef(null);
    const statisticsGeneralStatistics = useRef(null);
    const statisticsRobustStatistics = useRef(null);


    // Refs Charts
    const chartAutoregression = useRef(null);
    const chartAutoregressionStdRes = useRef(null);
    const chartBoxplot = useRef(null);
    const chartConfidenceIntervals = useRef(null);
    const chartDotplot = useRef(null);
    const chartHistogram = useRef(null);
    const chartTimeplot = useRef(null);
    const chartAutoregressionMulti = useRef(null);
    const chartRegressionMulti = useRef(null);
    const chartRegressionStdResMulti = useRef(null);
    const chartScatterMulti = useRef(null);
    const chartQQNormal = useRef(null);
    const chartQQLognormal = useRef(null);
    const chartQQBurr12 = useRef(null);

    let autoregPDF = 'empty';
    let autoregStdResPDF = 'empty';
    let boxplotPDF = 'empty';
    let confidenceIntervalsPDF = 'empty';
    let dotplotPDF = 'empty';
    let histogramPDF = 'empty';
    let timeplotPDF = 'empty';

    let autoregressionMultiPDF = 'empty';
    let regressionMultiPDF = 'empty';
    let regressionStdResMultiPDF = 'empty';
    let scatterplotMultiPDF = 'empty';
    let qqPlotPDFs = { normal: 'empty', lognormal: 'empty', burr12: 'empty' };

    let currentDate = moment().format('YYYY/MM/DD');
    let reportData = moment().format('DDMMYYYY');
    let reportTime = moment().format('HHmm');

    const changeSizeToPDF = (svg) => {
        return svg.replace(
            'width="600" height="400"',
            'width="2400" height="1600"'
        );
    };

    const captureQQPlots = (normalRef, lognormalRef, burr12Ref) => {
        const result = {
            normal: 'empty',
            lognormal: 'empty',
            burr12: 'empty'
        };
        
        if (normalRef.current?.chart) {
            result.normal = changeSizeToPDF(normalRef.current.chart.getSVG());
        }
        if (lognormalRef.current?.chart) {
            result.lognormal = changeSizeToPDF(lognormalRef.current.chart.getSVG());
        }
        if (burr12Ref.current?.chart) {
            result.burr12 = changeSizeToPDF(burr12Ref.current.chart.getSVG());
        }
        
        return result;
    };

    let strAutoregressionStatistics = '';
    let strConfidenceIntervalsStatistics = '';
    let strGeneralStatistics = '';
    let strRobustStatistics = '';

    // console.log(`props.getSvg`,props.getSvg)

    if (props.getSvg) {
        const outerHTML = (node) => {
            return (
                node.outerHTML || new XMLSerializer().serializeToString(node)
            );
        };
        if (
            chartAutoregression.current?.chart &&
            checkedList?.includes('autoregression')
        ) {
            autoregPDF = chartAutoregression.current.chart.getSVG();
            autoregPDF = changeSizeToPDF(autoregPDF);
            autoregStdResPDF = chartAutoregressionStdRes.current.chart.getSVG();
            autoregStdResPDF = changeSizeToPDF(autoregStdResPDF);

            strAutoregressionStatistics = outerHTML(
                statisticsAutoregression.current
            );
        }

        if (chartBoxplot.current?.chart && checkedList?.includes('boxplot')) {
            boxplotPDF = chartBoxplot.current.chart.getSVG();
            boxplotPDF = changeSizeToPDF(boxplotPDF);
        }
        if (
            chartConfidenceIntervals.current?.chart &&
            checkedList?.includes('confidence_intervals')
        ) {
            confidenceIntervalsPDF =
                chartConfidenceIntervals.current.chart.getSVG();
            confidenceIntervalsPDF = confidenceIntervalsPDF.replace(
                'width="600" height="280"',
                'width="2400" height="1,120"'
            );

            strConfidenceIntervalsStatistics = outerHTML(
                statisticsConfidenceIntervals.current
            );
        }
        if (chartDotplot.current?.chart && checkedList?.includes('dotplot')) {
            dotplotPDF = chartDotplot.current.chart.getSVG();
            dotplotPDF = changeSizeToPDF(dotplotPDF);
        }
        if (
            chartHistogram.current?.chart &&
            checkedList?.includes('histogram')
        ) {
            histogramPDF = chartHistogram.current.chart.getSVG();
            histogramPDF = changeSizeToPDF(histogramPDF);
        }

        if (checkedList?.includes('qq_plot')) {
            qqPlotPDFs = captureQQPlots(chartQQNormal, chartQQLognormal, chartQQBurr12);
        }


        if (checkedList?.includes('robust_statistics')) {
            strRobustStatistics = outerHTML(
                statisticsRobustStatistics.current
            );
        }

        // console.log('statisticsRobustStatistics.current', statisticsRobustStatistics.current);

        if (checkedList?.includes('statistics')) {
            strGeneralStatistics = outerHTML(
                statisticsGeneralStatistics.current
            );
        }
        if (chartTimeplot.current?.chart && checkedList?.includes('timeplot')) {
            timeplotPDF = chartTimeplot.current.chart.getSVG();
            timeplotPDF = changeSizeToPDF(timeplotPDF);
        }
        if (chartTimeplot.current?.chart && checkedList?.includes('timeplot')) {
            timeplotPDF = chartTimeplot.current.chart.getSVG();
            timeplotPDF = changeSizeToPDF(timeplotPDF);
        }

        if (
            chartAutoregressionMulti.current?.chart &&
            checkedList?.includes('autoregressionx')
        ) {
            autoregressionMultiPDF =
                chartAutoregressionMulti.current.chart.getSVG();
            autoregressionMultiPDF = changeSizeToPDF(autoregressionMultiPDF);
            strAutoregressionStatistics = outerHTML(
                statisticsAutoregression.current
            );
        }
        if (
            chartRegressionMulti.current?.chart &&
            (
                checkedList?.includes('regression') 
             || checkedList?.includes('robust_regression'))
        ) {
            regressionMultiPDF = chartRegressionMulti.current.chart.getSVG();
            regressionMultiPDF = changeSizeToPDF(regressionMultiPDF);

            regressionStdResMultiPDF =
                chartRegressionStdResMulti.current.chart.getSVG();
            regressionStdResMultiPDF = changeSizeToPDF(
                regressionStdResMultiPDF
            );

            qqPlotPDFs = captureQQPlots(chartQQNormal, chartQQLognormal, chartQQBurr12);

            strAutoregressionStatistics = outerHTML(
                statisticsAutoregression.current
            );
        }
        if (
            chartScatterMulti.current?.chart &&
            checkedList?.includes('scatterplot')
        ) {
            scatterplotMultiPDF = chartScatterMulti.current.chart.getSVG();
            scatterplotMultiPDF = changeSizeToPDF(scatterplotMultiPDF);
            qqPlotPDFs = captureQQPlots(chartQQNormal, chartQQLognormal, chartQQBurr12);
            
            strAutoregressionStatistics = outerHTML(
                statisticsAutoregression.current
            );
        }
        if (
            chartScatterMulti.current?.chart &&
            checkedList?.includes('robust_scatterplot')
        ) {
            scatterplotMultiPDF = chartScatterMulti.current.chart.getSVG();
            scatterplotMultiPDF = changeSizeToPDF(scatterplotMultiPDF);
            qqPlotPDFs = captureQQPlots(chartQQNormal, chartQQLognormal, chartQQBurr12);
            
            strAutoregressionStatistics = outerHTML(
                statisticsAutoregression.current
            );
        }
        if (
            chartScatterMulti.current?.chart &&
            checkedList?.includes('weighted_scatterplot')
        ) {
            scatterplotMultiPDF = chartScatterMulti.current.chart.getSVG();
            scatterplotMultiPDF = changeSizeToPDF(scatterplotMultiPDF);
            qqPlotPDFs = captureQQPlots(chartQQNormal, chartQQLognormal, chartQQBurr12);

            strAutoregressionStatistics = outerHTML(
                statisticsAutoregression.current
            );
        }
    }

    return (
        <>
            {props.spinnerFullProjectView ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 'calc(100vh - 128px'
                    }}
                >
                    <Loader />
                </div>
            ) : (
                <div
                    ref={refToScroll}
                    className="full-charts-project"
                    style={styleCss}
                >
                    {/* <div>{msgError}</div> */}

                    {getAnalysisRes?.autoregression ? (
                        getAnalysisRes?.autoregression?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Autoregression`}
                                    // header={autoregFailed}
                                    id="id-autoregression"
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.autoregression.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel key={1} header={`Autoregression ${getAnalysisRes.filter_by_variable == null ? '': `[${getAnalysisRes.filter_by_variable}]`}`}>
                                    <AutoregressionScatterplotChart
                                        getAnalysisRes={getAnalysisRes}
                                        forwardedRef={chartAutoregressionStdRes}
                                    />

                                    <AutoregressionChart
                                        getAnalysisRes={getAnalysisRes}
                                        forwardedRef={chartAutoregression}
                                    />

                                    <AutoregressionStatistics
                                        getAnalysisRes={getAnalysisRes}
                                        forwardedRefStatistics={
                                            statisticsAutoregression
                                        }
                                    />
                                </Panel>
                            </Collapse>
                        )
                    ) : null}

                    {getAnalysisRes?.boxplot ? (
                        getAnalysisRes?.boxplot?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Boxplot`}
                                    id="id-boxplot"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.boxplot.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <BoxplotChart
                                getAnalysisRes={getAnalysisRes}
                                forwardedRef={chartBoxplot}
                            />
                        )
                    ) : null}

                    {getAnalysisRes?.confidence_intervals ? (
                        getAnalysisRes?.confidence_intervals?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Confidence Intervals `}
                                    id="id-confidence_intervals"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.confidence_intervals.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel key={1} header={`Confidence Intervals ${getAnalysisRes.filter_by_variable == null ? '': `[${getAnalysisRes.filter_by_variable}]`}`}>
                                    <ConfidenceIntervalsChart
                                        getAnalysisRes={getAnalysisRes}
                                        forwardedRef={chartConfidenceIntervals}
                                    />

                                    <ConfidenceIntervalsStatistics
                                        getAnalysisRes={getAnalysisRes}
                                        forwardedRefStatistics={
                                            statisticsConfidenceIntervals
                                        }
                                    />
                                </Panel>
                            </Collapse>
                        )
                    ) : null}

                    {getAnalysisRes?.dotplot ? (
                        getAnalysisRes?.dotplot?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Dotplot`}
                                    id="id-dotplot"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.dotplot.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <DotplotChart
                                getAnalysisRes={getAnalysisRes}
                                forwardedRef={chartDotplot}
                            />
                        )
                    ) : null}

                    {getAnalysisRes?.histogram ? (
                        getAnalysisRes?.histogram?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Histogram`}
                                    id="id-histogram"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.histogram.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <HistogramChart
                                getAnalysisRes={getAnalysisRes}
                                forwardedRef={chartHistogram}
                            />
                        )
                    ) : null}

                    {getAnalysisRes?.qq_plot ? (
                        getAnalysisRes?.qq_plot?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Q-Q Plot`}
                                    id="id-qq-plot"
                                    style={{ color: 'red' }}
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.qq_plot.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <QQPlotChart
                                getAnalysisRes={getAnalysisRes}
                                forwardedRefNormal={chartQQNormal}
                                forwardedRefLognormal={chartQQLognormal}
                                forwardedRefBurr12={chartQQBurr12}
                            />
                        )
                    ) : null}

                    {getAnalysisRes?.robust_statistics ? (
                        getAnalysisRes?.robust_statistics?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Histogram`}
                                    id="id-robust_statistics"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.robust_statistics.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <RobustStatistics
                                getAnalysisRes={getAnalysisRes}
                                forwardedRef={statisticsRobustStatistics}
                            />
                        )
                    ) : null}

                    {getAnalysisRes?.statistics ? (
                        getAnalysisRes?.statistics?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Statistics`}
                                    id="id-statistics"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.statistics.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <GeneralStatistics
                                getAnalysisRes={getAnalysisRes}
                                forwardedRefStatistics={
                                    statisticsGeneralStatistics
                                }
                            />
                        )
                    ) : null}

                    {getAnalysisRes?.timeplot ? (
                        getAnalysisRes?.timeplot?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Timeplot`}
                                    id="id-timeplot"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.timeplot.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <TimeplotChart
                                getAnalysisRes={getAnalysisRes}
                                forwardedRef={chartTimeplot}
                                analysisData={props.analysisData[props.analysisActivePanel]}
                            />
                        )
                    ) : null}

                    {getAnalysisRes?.autoregressionx ? (
                        getAnalysisRes?.autoregressionx?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Autoregression X `}
                                    id="id-autoregressionx"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.autoregressionx.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <>
                                <Collapse
                                    bordered={false}
                                    defaultActiveKey={[1]}
                                >
                                    <Panel key={1} header={`Autoregression X`}>
                                        <AutoregressionMultiChart
                                            getAnalysisRes={getAnalysisRes}
                                            forwardedRef={
                                                chartAutoregressionMulti
                                            }
                                        />

                                        <AutoregressionStatistics
                                            getAnalysisRes={getAnalysisRes}
                                            forwardedRefStatistics={
                                                statisticsAutoregression
                                            }
                                        />
                                    </Panel>
                                </Collapse>
                                {getAnalysisRes?.autoregressionx
                                    ?.outliers_removed ? (
                                    <RemovedOutliersMultivariate
                                        getAnalysisRes={getAnalysisRes}
                                    />
                                ) : null}
                            </>
                        )
                    ) : null}

                    {getAnalysisRes?.regression ? (
                        getAnalysisRes?.regression?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Regression`}
                                    id="id-regression"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.regression.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <>
                                <RegressionMultiChart
                                    getAnalysisRes={getAnalysisRes}
                                    forwardedRef={chartRegressionMulti}
                                    forwardedRefStdRes={
                                        chartRegressionStdResMulti
                                    }
                                    forwardedRefQQPlotNormal={chartQQNormal}
                                    forwardedRefQQPlotLognormal={chartQQLognormal}
                                    forwardedRefQQPlotBurr12={chartQQBurr12}
                                    forwardedRefStatistics={
                                        statisticsAutoregression
                                    }
                                />
                                {getAnalysisRes?.regression
                                    ?.outliers_removed ? (
                                    <RemovedOutliersMultivariate
                                        getAnalysisRes={getAnalysisRes}
                                    />
                                ) : null}
                            </>
                        )
                    ) : null}

                    {getAnalysisRes?.robust_regression ? (
                        getAnalysisRes?.robust_regression?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Regression`}
                                    id="id-robust-regression"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.robust_regression.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <>
                                <RobustRegressionMultiChart
                                    getAnalysisRes={getAnalysisRes}
                                    forwardedRef={chartRegressionMulti}
                                    forwardedRefStdRes={
                                        chartRegressionStdResMulti
                                    }
                                    forwardedRefQQPlotNormal={chartQQNormal}
                                    forwardedRefQQPlotLognormal={chartQQLognormal}
                                    forwardedRefQQPlotBurr12={chartQQBurr12}
                                    forwardedRefStatistics={
                                        statisticsAutoregression
                                    }
                                />
                                {getAnalysisRes?.robust_regression
                                    ?.outliers_removed ? (
                                    <RemovedOutliersMultivariate
                                        getAnalysisRes={getAnalysisRes}
                                    />
                                ) : null}
                            </>
                        )
                    ) : null}

                    {getAnalysisRes?.scatterplot ? (
                        getAnalysisRes?.scatterplot?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Scatterplot`}
                                    id="id-scatterplot"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.scatterplot.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <>
                                <ScatterplotMultiChart
                                    getAnalysisRes={getAnalysisRes}
                                    scatterType='scatterplot'
                                    forwardedRef={chartScatterMulti}
                                forwardedRefQQPlotNormal={chartQQNormal}
                                forwardedRefQQPlotLognormal={chartQQLognormal}
                                forwardedRefQQPlotBurr12={chartQQBurr12}
                                    forwardedRefStatistics={
                                        statisticsAutoregression
                                    }
                                />

                                {getAnalysisRes?.scatterplot
                                    ?.outliers_removed ? (
                                    <RemovedOutliersMultivariate
                                        getAnalysisRes={getAnalysisRes}
                                    />
                                ) : null}
                            </>
                        )
                    ) : null}
                    {getAnalysisRes?.robust_scatterplot ? (
                        getAnalysisRes?.robust_scatterplot?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Robust Scatterplot`}
                                    id="id-robust_scatterplot"
                                    style={{ color: 'red' }}
                                    // collapsible="disabled"
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.robust_scatterplot.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <>
                                <ScatterplotMultiChart
                                    getAnalysisRes={getAnalysisRes}
                                    scatterType='robust_scatterplot'
                                    forwardedRef={chartScatterMulti}
                                forwardedRefQQPlotNormal={chartQQNormal}
                                forwardedRefQQPlotLognormal={chartQQLognormal}
                                forwardedRefQQPlotBurr12={chartQQBurr12}
                                    forwardedRefStatistics={
                                        statisticsAutoregression
                                    }
                                />

                                {getAnalysisRes?.robust_scatterplot
                                    ?.outliers_removed ? (
                                    <RemovedOutliersMultivariate
                                        getAnalysisRes={getAnalysisRes}
                                    />
                                ) : null}
                            </>
                        )
                    ) : null}

                    {getAnalysisRes?.weighted_scatterplot ? (
                        getAnalysisRes?.weighted_scatterplot?.message ? (
                            <Collapse bordered={false} defaultActiveKey={[1]}>
                                <Panel
                                    key={1}
                                    header={`Weighted Scatterplot`}
                                    id="id-weighted_scatterplot"
                                    style={{ color: 'red' }}
                                >
                                    <Alert
                                        message="Error"
                                        description={`${getAnalysisRes?.weighted_scatterplot.message}`}
                                        type="error"
                                    />
                                </Panel>
                            </Collapse>
                        ) : (
                            <>
                                <ScatterplotMultiChart
                                    getAnalysisRes={getAnalysisRes}
                                    scatterType='weighted_scatterplot'
                                    forwardedRef={chartScatterMulti}
                                    forwardedRefQQPlotNormal={chartQQNormal}
                                    forwardedRefQQPlotLognormal={chartQQLognormal}
                                    forwardedRefQQPlotBurr12={chartQQBurr12}
                                    forwardedRefStatistics={
                                        statisticsAutoregression
                                    }
                                />

                                {getAnalysisRes?.weighted_scatterplot
                                    ?.outliers_removed ? (
                                    <RemovedOutliersMultivariate
                                        getAnalysisRes={getAnalysisRes}
                                    />
                                ) : null}

                                <WlsExcludedRows
                                    getAnalysisRes={getAnalysisRes}
                                />
                            </>
                        )
                    ) : null}

                    {getAnalysisRes?.outliers_removed ? (
                        <RemovedOutliers getAnalysisRes={getAnalysisRes} />
                    ) : null}

                    {getAnalysisRes?.two_stage_least_squares ? (
                        <TslsMultiChart result={getAnalysisRes.two_stage_least_squares} />
                    ) : null}
                </div>

            )}

            {appContext.isModalExport && (
                <Modal
                    className="basic-modal-legal-notice"
                    title=""
                    visible={appContext.isModalExport}
                    onOk={onOkExport}
                    onCancel={onCancelExport}
                    footer={null}
                    closable={false}
                    bodyStyle={{ minHeight: 574 }}
                    width={360}
                >
                    <div className="icon-container">
                        <img
                            src={icon_export}
                            style={{
                                position: 'absolute',
                                top: '-50px',
                                left: '-50px'
                            }}
                        />
                    </div>
                    <div>
                        <div style={{ padding: '8px 0 0 0', marginLeft: 6 }}>
                            <p
                                className="header-title"
                                style={{ marginBottom: '30px' }}
                            >
                                Export Analysis
                            </p>

                            {props.analysisData[
                                props.analysisActivePanel
                            ]?.analysis_function.includes('autoregressionx') ||
                            props.analysisData[
                                props.analysisActivePanel
                            ]?.analysis_function.includes('regression') ||
                            props.analysisData[
                                props.analysisActivePanel
                            ]?.analysis_function.includes('scatterplot') ? (
                                <div style={{ height: 348 }}>
                                    <p
                                        style={{
                                            fontFamily: 'Roboto Regular',
                                            fontSize: '16px',
                                            lineHeight: '22px'
                                        }}
                                    >
                                        Click "EXPORT" button and choose a place
                                        on your disk where the analysis can be
                                        downloaded.
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <p
                                        style={{
                                            fontFamily: 'Roboto Regular',
                                            fontSize: '16px',
                                            lineHeight: '22px'
                                        }}
                                    >
                                        Please select the analysis/analyses you{' '}
                                        <br />
                                        wish to export.
                                    </p>
                                    <div className="container-choose-btn">
                                        <div className="cardd">
                                            <div
                                                onClick={() => {
                                                    handleOnClickAll();
                                                }}
                                                className={
                                                    allSelected
                                                        ? 'btn-all-selected'
                                                        : 'btn-all'
                                                }
                                            >
                                                ALL
                                            </div>
                                            <div
                                                onClick={() => {
                                                    handleOnClickNone();
                                                }}
                                                className={
                                                    noneSelected
                                                        ? 'btn-none-selected'
                                                        : 'btn-none'
                                                }
                                            >
                                                NONE
                                            </div>
                                        </div>
                                    </div>

                                    <div className="checkbox-export-analysis">
                                        <Checkbox.Group
                                            options={plainOptions}
                                            style={{
                                                width: '100%',
                                                display: 'flex'
                                            }}
                                            onChange={onChange}
                                            value={checkedList}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent:
                                                        'space-between',
                                                    width: '100%'
                                                }}
                                            ></div>
                                        </Checkbox.Group>
                                    </div>
                                </>
                            )}
                        </div>
                        <div
                            style={{
                                textAlign: 'center',
                                marginTop: 22,
                                padding: '0 5px',
                                marginBottom: '6px'
                            }}
                        >
                            {!props.getSvg ? (
                                'loading...'
                            ) : (
                                <PDFDownloadLink
                                    document={
                                        <PDFFile
                                            // Tables converted to html for Statistics
                                            strAutoregressionStatistics={
                                                strAutoregressionStatistics
                                            }
                                            strConfidenceIntervalsStatistics={
                                                strConfidenceIntervalsStatistics
                                            }
                                            strGeneralStatistics={
                                                strGeneralStatistics
                                            }
                                            strRobustStatistics={strRobustStatistics}
                                            // End Tables converted to html for Statistics
                                            currentDate={currentDate}
                                            analysisDataName={
                                                props.analysisData[
                                                    props.analysisActivePanel
                                                ]?.name
                                            }
                                            autoregPDF={autoregPDF}
                                            autoregStdResPDF={autoregStdResPDF}
                                            boxplotPDF={boxplotPDF}
                                            confidenceIntervalsPDF={
                                                confidenceIntervalsPDF
                                            }
                                            dotplotPDF={dotplotPDF}
                                            histogramPDF={histogramPDF}
                                            mainQQPlotPDFs={qqPlotPDFs}
                                            timeplotPDF={timeplotPDF}
                                            autoregressionMultiPDF={
                                                autoregressionMultiPDF
                                            }
                                            regressionMultiPDF={
                                                regressionMultiPDF
                                            }
                                            regressionStdResMultiPDF={
                                                regressionStdResMultiPDF
                                            }
                                            scatterplotMultiPDF={
                                                scatterplotMultiPDF
                                            }
                                            qqPlotPDFs={qqPlotPDFs}
                                        />
                                    }
                                    // document={<PDFFile />}
                                    fileName={`Analysis_${reportData}_${reportTime}`}
                                >
                                    {({ loading }) =>
                                        loading ? (
                                            <button
                                                onClick={onOkExport}
                                                // style={{ width: 223 }}
                                                className="ant-btn ant-btn-primary ant-btn-block blue-button"
                                            >
                                                LOADING..
                                            </button>
                                        ) : (
                                            <button
                                                onClick={onOkExport}
                                                // style={{ width: 223 }}
                                                className="ant-btn ant-btn-primary ant-btn-block blue-button"
                                            >
                                                EXPORT
                                            </button>
                                        )
                                    }
                                </PDFDownloadLink>
                            )}
                            {/* <button
                            onClick={onOkExport}
                            // style={{ width: 223 }}
                            className="ant-btn ant-btn-primary ant-btn-block blue-button"
                        >
                            EXPORT
                        </button> */}
                            <Button
                                onClick={onCancelExport}
                                style={{
                                    width: '100%',
                                    marginTop: 10,
                                    borderColor: '#578cba',
                                    color: '#578cba'
                                }}
                            >
                                CANCEL
                            </Button>
                        </div>
                    </div>
                </Modal>
                
            )}

        {showModalError? (
            <Modal
            className="basic-modal"
            title=""
            visible={errorModalIsVisible}
            onOk={handleErrorModalOk}
            onCancel={handleCancelErrorModal}
            footer={null}
            closable={false}
            bodyStyle={{ height: 450 }}
            width={300}
        >
            <div className="icon-container">
                <img
                    className="img-icon-container"
                    src={background_circle_red_modal}
                />
                <img
                    className="icon-in-green-circle"
                    src={icon_in_red_circle}
                />
            </div>
            <div>
                <div style={{ padding: '8px 0 0 0', marginLeft: 6 }}>
                    <p className="header-title">Something <br/> went wrong!</p>
                    <p className="p-desctiption">
                        Error occured! <br/>Try with another data.
                    </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <button
                        onClick={handleErrorModalOk}
                        style={{
                            width: 223
                        }}
                        className="ant-btn ant-btn-primary ant-btn-block blue-button"
                    >
                        OK
                    </button>
                </div>
            </div>
        </Modal>
        ):null}
            
        </>
    );
};

export default React.memo(FullProjectView, (prevProps, nextProps) => {
    return (
        prevProps.analysisId === nextProps.analysisId &&
        prevProps.spinnerFullProjectView === nextProps.spinnerFullProjectView &&
        prevProps.getSvg === nextProps.getSvg
    );
});
// export default FullProjectView;
